module.exports = __webpack_public_path__ + "CSGD-0ba6dabb.webp";